import { Grid } from "@material-ui/core";

export default function SmartGridItem({ children }: any) {
    return <Grid item xs={12} sm={12} md="auto">{children}</Grid>
}